import type { CloudInstance } from '@schema';

export const VM_STATUS = {
  POWERED_ON: 'poweredOn',
  POWERED_OFF: 'poweredOff',
  SUSPENDED: 'suspended',
} as const;

export type VMStatus = (typeof VM_STATUS)[keyof typeof VM_STATUS];

const VALID_STATUSES: readonly string[] = Object.values(VM_STATUS);

export interface MigrationVM {
  rowKey: string;
  id: string;
  name: string;
  cloudId: string;
  status: VMStatus;
  type: string;
  cpuCount: number;
  memoryMb: number;
}

export function toMigrationVM(instance: CloudInstance, cloudId: string): MigrationVM {
  const status = VALID_STATUSES.includes(instance.state)
    ? (instance.state as VMStatus)
    : VM_STATUS.POWERED_OFF;
  return {
    rowKey: `${instance.id}:${instance.name}`,
    id: instance.id,
    name: instance.name,
    cloudId,
    status,
    type: instance.os_type ?? '',
    cpuCount: instance.num_cpu ?? 0,
    memoryMb: instance.memory_mb ?? 0,
  };
}
